import 'css-chunksrc/client/scenes/event/timestamp/styles.scss';export default {
  "timestamp": "_timestamp_59jcu_1",
  "contextualMenu": "_contextualMenu_59jcu_6",
  "contextualMenuMultiProject": "_contextualMenuMultiProject_59jcu_12",
  "dates": "_dates_59jcu_16",
  "row": "_row_59jcu_20",
  "date": "_date_59jcu_16"
};